import { useEffect } from "react";

const SITE = "Resham Drops";
const DEFAULT_IMAGE =
    "https://customer-assets-jt897jd0.emergentagent.net/job_product-launch-111/artifacts/e5598ce1ed800374_WhatsApp%20Image%202026-10-06%20at%207.05.37%20PM.jpeg";

const setMeta = (attr, key, content) => {
    let el = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

const setCanonical = (href) => {
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

export function useSeo({ title, description, keywords, image, path, jsonLd, noindex = false }) {
    const ld = jsonLd ? JSON.stringify(jsonLd) : "";
    useEffect(() => {
        if (!title) return;
        const url = `${window.location.origin}${path ?? window.location.pathname}`;
        const img = image || DEFAULT_IMAGE;
        document.title = title;
        setMeta("name", "description", description);
        if (keywords) setMeta("name", "keywords", keywords);
        setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
        setMeta("property", "og:type", "website");
        setMeta("property", "og:site_name", SITE);
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", url);
        setMeta("property", "og:image", img);
        setMeta("name", "twitter:card", "summary_large_image");
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);
        setMeta("name", "twitter:image", img);
        setCanonical(url);

        let script = null;
        if (ld) {
            script = document.createElement("script");
            script.type = "application/ld+json";
            script.dataset.seo = "page";
            script.text = ld;
            document.head.appendChild(script);
        }
        return () => script?.remove();
    }, [title, description, keywords, image, path, ld, noindex]);
}

export const productJsonLd = (product, reviews) => {
    if (!product) return null;
    const prices = (product.bundles || []).map((b) => b.price);
    const rated = reviews?.count > 0
        ? {
              aggregateRating: {
                  "@type": "AggregateRating",
                  ratingValue: reviews.average,
                  reviewCount: reviews.count,
                  bestRating: 5,
              },
              review: reviews.reviews.slice(0, 5).map((r) => ({
                  "@type": "Review",
                  author: { "@type": "Person", name: r.name },
                  datePublished: r.created_at?.slice(0, 10),
                  reviewBody: r.text,
                  reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5 },
              })),
          }
        : {};
    return {
        ...rated,
        "@context": "https://schema.org",
        "@type": "Product",
        name: product.name,
        description: product.short_description || product.tagline,
        image: product.images || [],
        brand: { "@type": "Brand", name: SITE },
        category: product.category,
        sku: product.slug,
        offers: {
            "@type": "AggregateOffer",
            priceCurrency: "PKR",
            lowPrice: Math.min(...prices),
            highPrice: Math.max(...prices),
            offerCount: prices.length,
            availability: "https://schema.org/InStock",
            url: `${window.location.origin}/product/${product.slug}`,
            areaServed: "PK",
        },
    };
};

export const faqJsonLd = (faqs) =>
    faqs?.length
        ? {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map((f) => ({
                  "@type": "Question",
                  name: f.q,
                  acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
          }
        : null;

export const SEO_KEYWORDS =
    "hair growth serum Pakistan, rosemary hair oil, rosemary hair serum, hair fall treatment, hair fall solution Pakistan, scalp massager comb, serum applicator comb, baal girna ka ilaj, baal lambe karne ka tarika, ganjapan ka ilaj, Dermalist serum, Resham Drops, بال گرنے کا علاج";
